// ExplorePH3/client/src/components/BottomNav.jsx
import React from 'react';
import { MapPin, List, User, Compass } from 'lucide-react';
import { useLocation, useNavigate } from 'react-router-dom';

const BottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const navItems = [
    {
      id: 'explore',
      label: 'Explore',
      icon: Compass,
      path: '/',
      active: location.pathname === '/',
    },
    {
      id: 'map',
      label: 'Map',
      icon: MapPin,
      path: '/map',
      active: location.pathname === '/map',
    },
    {
      id: 'list',
      label: 'List',
      icon: List,
      path: '/list',
      active: location.pathname === '/list',
    },
    {
      id: 'profile',
      label: 'Profile',
      icon: User,
      path: '/profile',
      active: location.pathname === '/profile',
    },
  ];

  return (
    <nav className="bottom-nav safe-area-bottom">
      <div className="flex items-center justify-around h-16 px-4">
        {navItems.map((item) => {
          const Icon = item.icon;
          const isActive = item.active;
          
          return (
            <button
              key={item.id}
              onClick={() => navigate(item.path)}
              className="flex flex-col items-center justify-center w-20 h-full transition-all duration-200 active:scale-95"
              aria-label={item.label}
            >
              <div className="relative">
                <Icon
                  className={`w-6 h-6 transition-colors duration-200 ${
                    isActive
                      ? 'text-teal-600'
                      : 'text-gray-400'
                  }`}
                  strokeWidth={isActive ? 2.5 : 2}
                />
                {isActive && (
                  <div className="absolute -bottom-1 left-1/2 transform -translate-x-1/2 w-1 h-1 bg-teal-500 rounded-full"></div>
                )}
              </div>
              <span
                className={`text-xs mt-1 transition-colors duration-200 ${
                  isActive
                    ? 'text-teal-600 font-medium'
                    : 'text-gray-500'
                }`}
              >
                {item.label}
              </span>
            </button>
          );
        })}
      </div>
      
      {/* Safe area spacer for iOS */}
      <div className="h-4 bg-white"></div>
    </nav>
  );
};

export default BottomNav;